import Vue from 'vue';
import VueRouter from 'vue-router';
import Programs from '../views/Programs.vue';
import Login from '../views/Login.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/',
    name: 'Programs',
    component: Programs,
  },
  {
    path: '/dealers',
    name: 'Dealer-List',
    component: () => import(/* webpackChunkName: "preview" */ '../views/DealerList.vue'),
  },
  {
    path: '/forms',
    name: 'Field-Forms',
    component: () => import(/* webpackChunkName: "preview" */ '../views/FieldForms.vue'),
  },
  {
    path: '/dealer',
    name: 'Dealer',
    component: () => import(/* webpackChunkName: "preview" */ '../views/Dealer.vue'),
    children: [
      {
        path: '/dealer/:domain/:entity/dashboard/',
        name: 'Dashboard',
        component: () => import(/* webpackChunkName: "preview" */ '../components/DealerDashboard.vue'),
      },
      {
        path: '/dealer/:domain/:entity/pillar/',
        name: 'Pillars',
        component: () => import(/* webpackChunkName: "preview" */ '../components/Pillar.vue'),
      },
      {
        path: '/dealer/:domain/:entity/forms/',
        name: 'Dealer-Forms',
        component: () => import(/* webpackChunkName: "preview" */ '../components/DealerForms.vue'),
        children: [
          {
            path: '/dealer/:domain/:entity/forms/appeal/',
            name: 'Appeal',
            component: () => import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/AppealForm.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/ccAppeal/',
            name: 'CCAppeal',
            component: () => import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/CCAppealForm.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/wifi/',
            name: 'Wifi',
            component: () => import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/WifiForm.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/lounge/',
            name: 'Lounge',
            component: () => import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/LoungeForm.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/rental/',
            name: 'Rental',
            component: () => import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/RentalForm.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/survey/',
            name: 'Survey-Interference',
            component: () =>
              import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/SurveyInterferenceForm.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/facility/',
            name: 'Facility',
            component: () => import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/FacilityForm.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/Charging Equipment Acknowledgement/',
            name: 'Charging Equipment Acknowledgement',
            component: () =>
              import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/AcknowledgementForm.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/Safety Processes Acknowledgement/',
            name: 'Safety Processes Acknowledgement',
            component: () =>
              import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/AcknowledgementForm.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/Essential Tools & Required Service Equipment/',
            name: 'Essential Tools & Required Service Equipment',
            component: () =>
              import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/AcknowledgementForm.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/Dealer Infrastructure Requirements Acknowledgement/',
            name: 'Dealer Infrastructure Requirements Acknowledgement',
            component: () =>
              import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/AcknowledgementForm.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/Proof of Service Lift/',
            name: 'Proof of Service Lift',
            component: () => import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/ServiceLift.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/Proof of Forklift/',
            name: 'Proof of Forklift',
            component: () => import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/ForkLift.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/Complex Form/',
            name: 'Charging Equipment Installation And Activation',
            component: () => import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/ComplexForm.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/Level 2 Charging Equipment/',
            name: 'Level 2 Charging Equipment',
            component: () => import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/LevelTwoForm.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/DCFC Charging Equipment/',
            name: 'DCFC Charging Equipment',
            component: () => import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/DCFCForm.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/Final Installation Date of All Charging Equipment/',
            name: 'Final Installation Date of All Charging Equipment',
            component: () =>
              import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/FinalInstallationDate.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/Charging Management Software/',
            name: 'Charging Management Software',
            component: () =>
              import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/ChargingManagementSoftware.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/Acknowledgement of Facility Requirements/',
            name: 'Acknowledgement of Facility Requirements',
            component: () =>
              import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/AcknowledgementForm.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/Proof of Door Dimension/',
            name: 'Proof of Door Dimension',
            component: () =>
              import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/AcknowledgementUSPM.vue'),
          },
          {
            path: '/dealer/:domain/:entity/forms/Proof of Ceiling Height/',
            name: 'Proof of Ceiling Height',
            component: () =>
              import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/AcknowledgementUSPM.vue'),
          },
        ],
      },
      {
        path: '/dealer/:domain/:entity/archive/',
        name: 'Archive',
        component: () => import(/* webpackChunkName: "preview" */ '../components/Archive.vue'),
      },
      {
        path: '/dealer/:domain/:entity/program-rules/',
        name: 'Program-Rules',
        component: () => import(/* webpackChunkName: "preview" */ '../components/ProgramRules.vue'),
      },
      {
        path: '/dealer/:domain/:entity/help/',
        name: 'Dealer-Help',
        component: () => import(/* webpackChunkName: "preview" */ '../views/Help.vue'),
      },
      {
        path: '/dealer/:domain/:entity/securitycenter/',
        name: 'Dealer-Security-Center',
        component: () => import(/* webpackChunkName: "preview" */ '../views/SecurityCenter/DealerSecurityCenter.vue'),
      },
      {
        path: '/dealer/:domain/:entity/profile',
        name: 'Profile',
        component: () => import(/* webpackChunkName: "preview" */ '../views/SecurityCenter/Profile.vue'),
      },
      {
        path: '/dealer/:domain/:entity/surveyinterference',
        name: 'DealerSI',
        component: () => import(/* webpackChunkName: "preview" */ '../views/SurveyInterference/DealerSI.vue'),
        children: [
          {
            path: '/dealer/:domain/:entity/surveyinterference/letter/',
            name: 'Survey-Interference-Letter',
            component: () =>
              import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/SurveyInterferenceForm.vue'),
          },
          {
            path: '/dealer/:domain/:entity/surveyinterference/appealdetails',
            name: 'Appeal-Details',
            component: () =>
              import(/* webpackChunkName: "preview" */ '../components/SurveyInterference/AppealDetails.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/help',
    name: 'Help',
    component: () => import(/* webpackChunkName: "preview" */ '../views/Help.vue'),
  },
  {
    path: '/dashboard',
    name: 'CCDashboard',
    component: () => import(/* webpackChunkName: "preview" */ '../views/ControlCenter/Dashboard.vue'),
  },
  {
    path: '/messages',
    name: 'CCMessages',
    component: () => import(/* webpackChunkName: "preview" */ '../views/ControlCenter/Messages.vue'),
  },
  {
    path: '/forms',
    name: 'CCForms',
    component: () => import(/* webpackChunkName: "preview" */ '../views/ControlCenter/Forms.vue'),
  },
  {
    path: '/assets',
    name: 'CCAssets',
    component: () => import(/* webpackChunkName: "preview" */ '../views/ControlCenter/Assets.vue'),
  },
  {
    path: '/securitycenter',
    name: 'Field-Security-Center',
    component: () => import(/* webpackChunkName: "preview" */ '../views/SecurityCenter/FieldSecurityCenter.vue'),
  },
  {
    path: '/communicationcenter',
    name: 'CCCommunicationcenter',
    component: () => import(/* webpackChunkName: "preview" */ '../views/ControlCenter/CommunicationCenter.vue'),
  },
  {
    path: '/surveyinterference',
    name: 'FieldSI',
    component: () => import(/* webpackChunkName: "preview" */ '../views/SurveyInterference/FieldSI.vue'),
    children: [
      {
        path: '/surveyinterference/summary/',
        name: 'Summary',
        component: () => import(/* webpackChunkName: "preview" */ '../views/SurveyInterference/DealerSI.vue'),
        children: [
          {
            path: '/surveyinterference/summary/letter/',
            name: 'Survey-Interference-Letter-Field',
            component: () =>
              import(/* webpackChunkName: "preview" */ '../components/Forms/Dealer/SurveyInterferenceForm.vue'),
          },
          {
            path: '/surveyinterference/summary/appealdetails/',
            name: 'Appeal-Details-Field',
            component: () =>
              import(/* webpackChunkName: "preview" */ '../components/SurveyInterference/AppealDetails.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/lookup',
    name: 'UserLookup',
    component: () => import(/* webpackChunkName: "preview" */ '../views/UserLookup.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    // Scroll to the top of the page on route navigation
    return { x: 0, y: 0 };
  },
  routes,
});

export default router;
